import Asyncview from 'shopify-asyncview';
import morphdom from 'morphdom';
import rimg from 'rimg-shopify';
import CurrencyConverter from 'shopify-currency-converter';

export default class StaticCart {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);
    this.cartTable = this.el.querySelector('[data-cart-table]');
    this.cartDiscountContainer = this.el.querySelector('[data-cart-discount-container]');
    this.totalPrice = this.el.querySelector('[data-total-price]');
    this.$quantityInputs = null;
    this.$removeItem = null;
    this.updateTimeout = null;
    $('.get-rates').on('click', () => this.getRates());
    $('.cart-instructions textarea').on('change', () => this.saveSpecialInstructions());
    this.initializedClass = 'cart-initialized';
    this.hasShippingCalculator = section.data.hasShippingCalculator;

    this._bindCartItemEvents();
    this._validate();
  }

  _bindCartItemEvents() {
    this.$quantityInputs = $('[data-quantity-key]', this.$el);
    this.$removeItem = $('[data-remove-item]', this.$el);
    this.cartTable = this.el.querySelector('[data-cart-table]');
    this.cartDiscountContainer = this.el.querySelector('[data-cart-discount-container]');
    this.totalPrice = this.el.querySelector('[data-total-price]');

    this.$quantityInputs.each((i, el) => {
      $(el).on('input', (event) => this._updateItemQuantity(event));
    });

    this.$removeItem.each((i, el) => {
      $(el).on('click', (event) => this._updateItemQuantity(event));
    });
  }

  _unbindCartItemEvents() {
    this.$quantityInputs.each((i, el) => {
      $(el).off('input');
    });

    this.$removeItem.each((i, el) => {
      $(el).off('click');
    });

    this.$quantityInputs = null;
    this.$removeItem = null;
  }

  update() {
    // Resets the @$el for the current closure
    this._validate();
  }

  onSectionUnload() {
    $('.get-rates').off('click');
    $('.cart-instructions textarea').off('change');
  }

  _validate() {
    if (this.hasShippingCalculator) {
      this.shippingCalculator();
      if (Theme.customerLoggedIn && Theme.customerAddress && Theme.customerAddress.country) {
        this.calculateShipping(true);
      }
    }

    return Shopify.onError = XMLHttpRequest => this.handleErrors(XMLHttpRequest);
  }

  _updateItemQuantity(event) {
    event.preventDefault();

    let $quantityInput;
    let quantity;
    let lineItemKey;

    if (event.currentTarget.hasAttribute('data-remove-item')) {
      quantity = 0;
      lineItemKey = event.currentTarget.dataset.removeItem;
    } else {
      $quantityInput = $(event.currentTarget);
      quantity = $quantityInput.val();
      if (quantity == "") {
        return;
      }
      lineItemKey = $quantityInput.data('quantity-key');
    }

    // cancel any pending requests
    if (this.updateTimeout !== null) {
      clearTimeout(this.updateTimeout);
    }

    this.updateTimeout = setTimeout(() => {
      // Debounce to avoid firing requests while user is still entering number

      const thisTimeoutId = this.updateTimeout;
      window.Shopify.changeItem(lineItemKey, quantity, (cart) => {
        // If another request is in progress, discard this update
        if (this.updateTimeout && this.updateTimeout !== thisTimeoutId) {
          return;
        }
        if (cart.item_count === 0) {
          // reload to show empty cart state
          window.location.reload();
          return;
        }
        this.updateCart(cart, thisTimeoutId);
      });
    }, 300);
  }

  updateCart(cart, timeoutId) {
    const cartCount = cart.item_count;
    $('.cart-count-number').text(cart.item_count);

    // Swap the cart contents to update discount labels.
    Asyncview.load(
      '/cart',
      'ajax',
    )
      .done(({ options, html }) => {
        // If another request is in progress, discard this update
        if (this.updateTimeout !== timeoutId) {
          return;
        }

        this._unbindCartItemEvents();

        // Inject new cart table contents
        const newTableContainer = document.createElement('div');
        newTableContainer.innerHTML = html.table;

        morphdom(
          this.cartTable,
          newTableContainer.querySelector('table'),
          {
            onBeforeElUpdated: (fromEl, toEl) => {
              // Skip images if src matches
              // - we don't want to reload lazy loaded images
              if (fromEl.tagName === 'IMG' && fromEl.src === toEl.src) {
                return false;
              }
              return true;
            },
          },
        );

        this.cartTable.querySelectorAll('.money').forEach(money => CurrencyConverter.update(money));
        rimg.watch(this.cartTable);

        // Inject new cart level discounts
        const newDiscountContainer = document.createElement('div');
        newDiscountContainer.innerHTML = html.discounts;
        this.cartDiscountContainer.innerHTML = newDiscountContainer.querySelector('[data-cart-discount-container]').innerHTML;
        this.cartDiscountContainer.querySelectorAll('.money').forEach(money => CurrencyConverter.update(money));

        // Update total
        this.totalPrice.innerHTML = options.totalPrice;
        CurrencyConverter.update(this.totalPrice);

        this._bindCartItemEvents(this.$el);
      })
      .fail(() => window.location.reload());

  }

  saveSpecialInstructions() {
    const newNote = $('.cart-instructions textarea').val();
    return Shopify.updateCartNote(newNote, (cart) => {
      // empty function so that Shopify's callback isn't invoked
    });
  }

  updateShippingLabel(select) {
    if (select) {
      select = $(select);
      const selectedVariant = select.find('option:selected').val();
      select.prev('.selected-option').text(selectedVariant);
    }
  }

  shippingCalculator() {
    Shopify.Cart.ShippingCalculator.show({
      submitButton: Theme.shippingButton,
      submitButtonDisabled: Theme.shippingDisabled,
      customerIsLoggedIn: Theme.customerLoggedIn,
      moneyFormat: Theme.moneyFormat,
    });

    const selectableOptions = $('.cart-shipping-calculator select');

    setTimeout(() => {
      selectableOptions.map((index, select) => this.updateShippingLabel(select));
    },
    1);

    /* TODO: A race condition here prevents the state/province select
     * from updating when the country changes (since at least v4.0.0).
     * I've added a timeout as a temporary fix, but we should find a
     * more reliable solution.
     * */
    selectableOptions.change((e) => {
      selectableOptions.each((index, select) => {
        setTimeout(() => {
          this.updateShippingLabel(select);
        }, 1);
      });
    });
  }

  getRates() {
    return this.calculateShipping();
  }

  calculateShipping(auto) {
    let shippingAddress;
    const shippingCalculatorResponse = $('.cart-shipping-calculator-response', this.$el);
    shippingCalculatorResponse.empty().append("<p class='shipping-calculator-response message'/><ul class='shipping-rates'/>");
    const ratesFeedback = $('.shipping-calculator-response');

    $('.get-rates', this.$el).val(Theme.shippingDisabled);

    if (auto) {
      shippingAddress = Theme.customerAddress;
    } else {
      shippingAddress = {
        zip: $('.address-zip', this.$el).val() || '',
        country: $('.address-country', this.$el).val() || '',
        province: $('.address-province', this.$el).val() || '',
      };
    }

    Shopify.getCartShippingRatesForDestination(shippingAddress, (rates) => {
      let response;
      $('.shipping-rates').empty();
      let address = `${shippingAddress.zip}, ${shippingAddress.province}, ${shippingAddress.country}`;
      if (!shippingAddress.province.length) {
        address = `${shippingAddress.zip}, ${shippingAddress.country}`;
      }
      if (!shippingAddress.zip.length) {
        address = `${shippingAddress.province}, ${shippingAddress.country}`;
      }
      if (!shippingAddress.province.length || !shippingAddress.zip.length) {
        address = shippingAddress.country;
      }

      if (rates.length > 1) {
        const firstRate = Shopify.Cart.ShippingCalculator.formatRate(rates[0].price);
        response = Theme.shippingCalcMultiRates.replace('**address**', address).replace('**number_of_rates**', rates.length).replace('**rate**', `<span class='money'>${firstRate}</span>`);
        ratesFeedback.html(response);
      } else if (rates.length === 1) {
        response = Theme.shippingCalcOneRate.replace('**address**', address);
        ratesFeedback.html(response);
      } else {
        ratesFeedback.html(Theme.shippingCalcNoRates);
      }

      for (let i = 0; i < rates.length; i++) {
        const rate = rates[i];
        const price = Shopify.Cart.ShippingCalculator.formatRate(rate.price);
        const rateValues = Theme.shippingCalcRateValues.replace('**rate_title**', rate.name).replace('**rate**', `<span class='money'>${price}</span>`);
        $('.shipping-rates').append(`<li>${rateValues}</li>`);
      }

      return $('.get-rates').val(Theme.shippingButton);
    });
  }

  handleErrors(errors) {
    let errorMessage = $.parseJSON(errors.responseText);
    errorMessage = Theme.shippingCalcErrorMessage.replace('**error_message**', errorMessage.zip);
    $('.cart-shipping-calculator-response').html(`<p>${errorMessage}</p>`);
    return $('.get-rates').val(Theme.shippingButton);
  }
}
